import React, { useEffect, useState } from "react";
import { ClientDashboardChart } from "../../../components";
import like from "../../../assests/like.svg";
import search_icon from "../../../assests/search_icon.svg";
import user_profile from "../../../assests/user_profile.png";
import media from "../../../assests/media.svg";
import { LeadsCard, ConversionRatePieChart } from "../../../components";
import { handleApi } from "../../../utils/authentication";
import NewDashboardHome from "./new_dashboard/NewDashboardHome";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { main_dashboard } from "../client-tour/dashboards/main_dashboard"
import { getSvgIcons } from "../../../helpers/getReactIcons";
import useClientTour from "../../../hooks/useClientTour";

const DashboardsHome = () => {
  const [dashboardsHomeData, setDashboardsHomeData] = useState();
  const [loading, setLoading] = useState();
  const filter = useSelector((state) => state?.filter?.filter_date_range)
  const user = useSelector((state) => state?.user)
  const tour = useSelector((state) => state?.tour)
  const navigate = useNavigate()

  useClientTour({
    enabled: !user?.has_seen_tour && !tour?.main_dashboard && user?.is_client,
    steps: main_dashboard,
    tourKey: "main_dashboard",
    nextRoute: "/client/settings/",
    skipRoute: "/client/dashboards/home",
  });

  

  const handleNavigation = (redirect_link) => {
    if (redirect_link != "") {
      navigate(redirect_link)
    }

  }


  const firstBlock = [
    {
      name: "Paid Social",
      clicks: dashboardsHomeData?.paid_social?.clicks ?? 0,
      impressions: dashboardsHomeData?.paid_social?.impressions ?? 0, // in currency
      spend: dashboardsHomeData?.paid_social?.spend ?? 0,
      campaigns_count: dashboardsHomeData?.paid_social?.campaigns_count ?? 0,
      icon: like,
      border_color: "#B777F3",
      redirect_link: '/client/dashboards/paid_social',
      tooltip:`Facebook Ads:${dashboardsHomeData?.facebook?.campaigns_count} ,Snapchat Ads:${dashboardsHomeData?.snapchat?.campaigns_count} ,LinkedIn Ads:${dashboardsHomeData?.linkedin?.campaigns_count}`,
      type:"ads"
    },
    {
      name: "Paid Media",
      clicks: dashboardsHomeData?.paid_media?.clicks ?? 0,
      impressions: dashboardsHomeData?.paid_media?.impressions ?? 0, // in currency
      spend: dashboardsHomeData?.paid_media?.spend ?? 0,
      icon: media,
      border_color: "#F580C7",
      campaigns_count: dashboardsHomeData?.paid_media?.campaigns_count ?? 0,
      redirect_link: '/client/dashboards/paid_media',
      tooltip:`Google Ads:${dashboardsHomeData?.paid_media?.campaigns_count}`,
      type:"ads"
    },
    {
      name: "Organic Social",
      clicks: dashboardsHomeData?.organic_social?.total_clicks ?? 0,
      impressions: dashboardsHomeData?.organic_social?.total_impressions ?? 0, // in currency
      shares: dashboardsHomeData?.organic_social?.total_shares ?? 0,
      spend:  0,
      icon: media,
      border_color: "#F580C7",
      posts_count: dashboardsHomeData?.organic_social?.total_posts ?? 0,
      redirect_link: '/client/dashboards/organic_social',
      tooltip:`Facebook Posts:${dashboardsHomeData?.organic_social?.facebook_posts?.total_posts} ,Instagram Posts:${dashboardsHomeData?.organic_social?.instagram_posts?.total_posts} ,LinkedIn Posts:${dashboardsHomeData?.organic_social?.linkedin_posts?.total_posts}`,
      type:"posts"
    },
  ];

  const convertion_rate = [
    {
      socialMedia: "Social Media",
      conversionRate: 25,
      backgroundColor: ["#BB73FF", "#E7E8F2"],
    },
    {
      socialMedia: "Advertisements",
      conversionRate: 35,
      backgroundColor: ["#FF7DCB", "#E7E8F2"],
    },
    {
      socialMedia: "Owned",
      conversionRate: 40,
      backgroundColor: ["#38DFEC", "#E7E8F2"],
    },
    {
      socialMedia: "Search",
      conversionRate: 15,
      backgroundColor: ["#FFE58A", "#E7E8F2"],
    },
  ];

  const fetchDashboardsHomeMetrics = async () => {
    try {
      setLoading(true);
      let endpoint = "get_dashboard_home_metrics";
      let formData = new FormData();
      formData.append('client_id', user?.client_id)
      if (filter?.days?.value == 'Custom Range') {
        formData.append('start_date', filter?.startDate)
        formData.append('end_date', filter?.endDate)
      } else if (filter?.value) {
        formData.append('days', filter?.value)
      }
      let response = await handleApi(endpoint, "POST", {}, formData);
      if (response?.success) {
        setDashboardsHomeData(response);
      }
    } catch (e) {
      setDashboardsHomeData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardsHomeMetrics();
  }, [filter]);

  const barGraphData = [
    {
      label: 'Paid Social',
      backgroundColor: '#D3A4FF',
      borderColor: '#D3A4FF',
      borderWidth: 1,
      data: [dashboardsHomeData?.paid_social?.clicks, dashboardsHomeData?.paid_social?.impressions, dashboardsHomeData?.paid_social?.spend] // Leads data
    },
    {
      label: 'Paid Media',
      backgroundColor: '#FFB1E0', // Green bars
      borderColor: '#FFB1E0',
      borderWidth: 1,
      data: [dashboardsHomeData?.paid_media?.clicks, dashboardsHomeData?.paid_media?.impressions, dashboardsHomeData?.paid_media?.spend]
    },
    {
      label: 'Organic Social',
      backgroundColor: '#95F3FA', // Red bars
      borderColor: '#95F3FA',
      borderWidth: 1,
      data: [dashboardsHomeData?.organic_social?.total_clicks, dashboardsHomeData?.organic_social?.total_impressions, dashboardsHomeData?.organic_social?.total_shares]
    },

  ]



  return (
    <>
      {loading && <LoadingSpinner />}
      {!user?.status && <div className="d-flex justify-content-center align-items-center" >
        <div className="d-flex flex-column gap-2">
          <h5>Your account is Not Active</h5>
          <p>Please contact your administrator</p>
        </div>
      </div>}
      {!loading && user?.status &&
        <div className="d-flex flex-column gap_lg">
          <div className="social_media_campaigns_wrapper  ">
            {firstBlock?.map((item) => {
              let className = item?.name?.replace(' ', '_').toLowerCase()
              return (
                <div key={item?.name} className={`row social_media_campaigns_card mx-4 py-2 d-flex align-items-center ${className}`}>
                  <div className="col-md-4 col-sm-12 px-sm-0 py-sm-2">
                    <div className="d-flex gap-3 align-items-center" style={{ cursor: 'pointer' }} onClick={() => handleNavigation(item?.redirect_link)}>
                      <div
                        className="icon_div d-flex justify-content-center align-items-center"
                        style={{ borderColor: item?.border_color }}
                      >
                        <img
                          src={item?.icon}
                          style={{ width: "1.5vw", height: "3vh" }}
                        />
                      </div>
                      <div className="heading d-block  " >
                        {item?.type == "ads" ? (
                        <div className="">
                         <h5 className="border_bottom pb-1 m-0">{item?.name}</h5>
                        <span >{item?.campaigns_count} Total Campaigns</span>
                        <span data-bs-toggle="tooltip" className="px-1" data-bs-placement="left" title={item?.tooltip}>{getSvgIcons('info',{})}</span>
                        </div>
                      ) : (
                        <div className="">
                         <h5 className="border_bottom pb-1 m-0">{item?.name}</h5>
                        <span >{item?.posts_count} Total Posts</span> 
                         <span data-bs-toggle="tooltip" className="px-1" data-bs-placement="left" title={item?.tooltip}>{getSvgIcons('info',{})}</span>
                        </div>
                      )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-12  metrics ">
                    <div className="row pb-2 ">
                      {item?.type == "ads" ? (
                      <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                       <span>SPEND</span>
                        <div className="d-flex gap-2 align-items-sm-center">
                          <p className="mb-0 ">${item.spend}</p>
                        </div>
                      </div>):(
                        <>
                        <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                        {/* <span>SHARE</span> */}
                        <span>SPEND</span>
                        <div className="d-flex gap-2 align-items-sm-center">
                          {/* <p className="mb-0 ">{item.shares}</p> */}
                          <p className="mb-0 ">_</p>
                        </div>
                      </div>
                      
                        </>
                      )}
                      <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                        <span>CLICKS</span>
                        <div className="d-flex gap-2 align-items-sm-center">
                          <p className="mb-0 ">{item.clicks}</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                        <span>IMPRESSIONS</span>
                        <div className="d-flex gap-2 align-items-sm-center">
                          <p className="mb-0 ">{item.impressions}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-3 col-sm-12">
                <ClientDashboardChart border_color={item?.border_color} />
              </div> */}
                </div>
              );
            })}
            <div className="row social_media_campaigns_card mx-4 py-2 d-flex align-items-center owned_media">
              <div className="col-md-4 col-sm-12 px-sm-0 py-sm-2">
                <div className="d-flex gap-3 align-items-center" style={{ cursor: 'pointer' }} onClick={() => handleNavigation('/client/dashboards/owned_media')}>
                  <div
                    className="icon_div d-flex justify-content-center align-items-center"
                    style={{ borderColor: "#38DFEC" }}
                  >
                    <img
                      src={user_profile}
                      style={{ width: "1.5vw", height: "3vh" }}
                    />
                  </div>
                  <div className="heading">
                    <h5 className="border_bottom pb-1 m-0">{"Owned Media"}</h5>
                    <span >
                      {dashboardsHomeData?.owned_media?.properities_count ?? 0}{" "}
                      Total Properities
                    </span>
                       <span className="px-1" data-bs-toggle="tooltip" data-bs-placement="left" title={`${dashboardsHomeData?.owned_media?.properities_count} Domains ,${dashboardsHomeData?.owned_media?.total_links} Links`}>{getSvgIcons('info',{})}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-8 col-sm-12  metrics ">
                <div className="row pb-2 ">
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    {/* <span>SCREEN PAGE VIEWS</span> */}
                    <span>SPEND</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      {/* <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics
                      ?.screen_page_views ?? 0}
                  </p> */}
                      <p className="mb-0 ">
                       {/* {dashboardsHomeData?.owned_media?.metrics?.screen_page_views ?? 0} */}
                       _
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    {/* <span>BOUNCE RATE</span> */}
                    <span>CLICKS</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      {/* <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics?.bounce_rate?.toFixed(2) ?? 0}
                  </p> */}
                      <p className="mb-0 ">
                      {/* {dashboardsHomeData?.owned_media?.metrics?.sessions ?? 0} */} _
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    {/* <span>SESSIONS</span> */}
                    <span>IMPRESSIONS</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      {/* <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics?.sessions ?? 0}
                  </p> */}
                      <p className="mb-0 ">
                     _
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3 col-sm-12">
            <ClientDashboardChart border_color={"#38DFEC"} />
          </div> */}
            </div>
            <div className="row social_media_campaigns_card mx-4 py-2 d-flex align-items-center search">
              <div className="col-md-4 col-sm-12 px-sm-0 py-sm-2">
                <div className="d-flex gap-3 align-items-center">
                  <div
                    className="icon_div d-flex justify-content-center align-items-center"
                    style={{ borderColor: "#FFE58A" }}
                  >
                    <img
                      src={search_icon}
                      style={{ width: "1.5vw", height: "3vh" }}
                    />
                  </div>
                  <div className="heading">
                    <h5 className="border_bottom pb-1 m-0">{"Search"}</h5>
                    <span>
                      {dashboardsHomeData?.semrush?.campaigns_count ?? 0} Total
                      Campaigns
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-8 col-sm-12  metrics ">
                <div className="row pb-2 ">
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    <span>SPEND</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 ">
                        ${dashboardsHomeData?.semrush?.spend ?? 0}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    <span>CLICKS</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 ">
                        {dashboardsHomeData?.semrush?.clicks ?? 0}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                    <span>IMPRESSIONS</span>
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 ">
                        {dashboardsHomeData?.semrush?.impressions ?? 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3 col-sm-12">
            <ClientDashboardChart border_color={"#38DFEC"} />
          </div> */}
            </div>
            <div
              className="row social_media_campaigns_card py-4 px-4 text-white total_metrics"
              style={{ background: "#7F56D9" }}
            >
              <div className="col-md-4 col-sm-12 py-2 d-flex align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <div className="heading">
                    <h5 className="mb-2  text-white">Total</h5>
                    <span className=" text-white">
                      {dashboardsHomeData?.total.campaigns_count || 0} Total
                      Campaigns
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-8 metrics">
                <div className="row ">
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <span className=" text-white">SPEND</span>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <span className=" text-white">CLICKS</span>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <span className=" text-white">IMPRESSIONS</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 text-white">
                        ${dashboardsHomeData?.total?.total_spend || 0}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 text-white">
                        {dashboardsHomeData?.total?.total_clicks || 0}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 py-md-2">
                    <div className="d-flex gap-2 align-items-sm-center">
                      <p className="mb-0 text-white">
                        {dashboardsHomeData?.total?.total_impressions || 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">{/* <ClientDashboardChart /> */}</div>
            </div>
          </div>
          {/* <div className="social_media_campaigns_wrapper  ">
        <div className="row social_media_campaigns_card mx-4 py-2 d-flex align-items-center">
          <div className="col-md-3 col-sm-12 px-sm-0 py-sm-2">
            <div className="d-flex gap-3 align-items-center">
              <div
                className="icon_div d-flex justify-content-center align-items-center"
                style={{ borderColor: "#38DFEC" }}
              >
                <img
                  src={user_profile}
                  style={{ width: "1.5vw", height: "3vh" }}
                />
              </div>
              <div className="heading">
                <h5 className="border_bottom pb-1 m-0">{"Owned Media"}</h5>
                <span>
                  {dashboardsHomeData?.owned_media?.properities_count ?? 0}{" "}
                  Total Properities
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12  metrics ">
            <div className="row pb-2 ">
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>SCREEN PAGE VIEWS</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics
                      ?.screen_page_views ?? 0}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>BOUNCE RATE</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics?.bounce_rate?.toFixed(2) ?? 0}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>SESSIONS</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.owned_media?.metrics?.sessions ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <ClientDashboardChart border_color={"#38DFEC"} />
          </div>
        </div>
        <div className="row social_media_campaigns_card mx-4 py-2 d-flex align-items-center">
          <div className="col-md-3 col-sm-12 px-sm-0 py-sm-2">
            <div className="d-flex gap-3 align-items-center">
              <div
                className="icon_div d-flex justify-content-center align-items-center"
                style={{ borderColor: "#FFE58A" }}
              >
                <img
                  src={search_icon}
                  style={{ width: "1.5vw", height: "3vh" }}
                />
              </div>
              <div className="heading">
                <h5 className="border_bottom pb-1 m-0">{"Search"}</h5>
                <span>
                  {dashboardsHomeData?.semrush?.campaigns_count ?? 0} Total
                  Campaigns
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12  metrics ">
            <div className="row pb-2 ">
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>SPEND</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.semrush?.spend ?? 0}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>CLICKS</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.semrush?.clicks ?? 0}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 py-md-2 d-flex flex-column gap-2">
                <span>IMPRESSIONS</span>
                <div className="d-flex gap-2 align-items-sm-center">
                  <p className="mb-0 ">
                    {dashboardsHomeData?.semrush?.impressions ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <ClientDashboardChart border_color={"#38DFEC"} />
          </div>
        </div>
      </div> */}

          {/* leads card
          <div className="chart-section" >
            <LeadsCard bar_graph_data={barGraphData} labels={['Clicks', 'Impressions', 'Spend']} />
          </div> */}

          {/* <div className="">
        <div className="conversion_rate_card_wrapper px-4 ">
          <div className="heading  pt-4 pb-2">
            <h5>Conversion Rate Per source</h5>
          </div>
          <div className="row py-4 px-2 ">
            {convertion_rate?.map((item) => {
              return (
                <div className="col-md-3 ">
                  <div className="conversion_rate_card my-2">
                    <div className="row  px-4 py-3">
                      <div className="col-md-6 col-6 d-flex align-items-center">
                        <div className="h-100 d-flex flex-column gap-2 justify-content-center ">
                          <span className="y-3">{item?.socialMedia}</span>
                          <h5>{item?.conversionRate}%</h5>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <ConversionRatePieChart
                          backgroundColor={item?.backgroundColor}
                          conversionRate={item?.conversionRate}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div> */}

          <NewDashboardHome

            total={dashboardsHomeData?.total}
            paid_social={dashboardsHomeData?.paid_social}
            paid_social_facebook={dashboardsHomeData?.facebook}
            paid_social_snapchat={dashboardsHomeData?.snapchat}
            paid_social_instagram={dashboardsHomeData?.instagram}
            paid_social_linkedin={dashboardsHomeData?.linkedin}
            organic_social_data={dashboardsHomeData?.organic_social}
            paid_media={dashboardsHomeData?.paid_media}
            owned_media={dashboardsHomeData?.owned_media}


          />
            {/* leads card */}
          <div className="chart-section" >
            <LeadsCard bar_graph_data={barGraphData} labels={['Clicks', 'Impressions', 'Spend']} />
          </div>

        </div>
        
        }
    </>
  );
};

export default DashboardsHome;
